@if (formTemplate$ | async; as formTemplate) {
  <form (ngSubmit)="submit$.next(form.getRawValue())"
        [formGroup]="form" class="pb-4">
    <formly-form [fields]="formTemplate" [form]="form" [model]="item" [options]="options">
    </formly-form>
    @if (!readonly) {
      <div class="w-full flex flex-wrap justify-end gap-4">
        @if (showCancel) {
          <button (click)="cancel$.next()"
                  class="w-full sm:w-auto sm:!min-w-[200px]"
                  matButton
                  type="button">
            {{ 'common.cancel' | translate }}
          </button>
        }
        @if (showSubmit) {
          <button [disabled]="!form.valid"
                  class="w-full sm:w-auto sm:!min-w-[200px]"
                  matButton="filled"
                  type="submit">{{ submitActionText | translate }}
          </button>
        }
      </div>
    }
  </form>
} @else {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
